var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.16,15.23L24.88,2.51l-.45-.24h-.93L1.81,15.34c-.67,.4-.97,1.21-.74,1.95,.22,.7,.87,1.18,1.61,1.18h1.56v26.69c0,.32,.26,.58,.58,.58h13.78v-14.39h11.33v14.39h13.78c.32,0,.57-.26,.57-.57V18.47h1.02c.77-.03,1.43-.54,1.65-1.27,.22-.76-.1-1.57-.78-1.97Zm-5.28,27.12h-7.57v-13.26c0-.63-.51-1.13-1.13-1.13h-15.84c-.63,0-1.13,.51-1.13,1.13v13.26H7.62V15.7L23.99,5.92l16.9,10.1v26.33Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.4afd5ea890d0c6c5be9c71cd577985f8.svg";
export { ForwardRef as ReactComponent };